/* [HOK-OWNER: Khiz | BUILT-WITH: Claude Code | PROJECT: extrait-popup | SINCE: 2026-09-29] */
/*
  HOK Extrait upgrade popup: engine.

  Loaded on every page by snippets/hok-extrait-popup.liquid, which is rendered
  from snippets/global-button-fix.liquid because all five layouts (theme and
  the four GemPages layouts) already load that snippet.
  Settings: Theme settings > Extrait upgrade popup.

  When a shopper adds an Eau de Parfum bottle that has an Extrait de Parfum
  twin (same size), the add waits while the popup asks. "Add to cart" swaps
  in the Extrait version, "No thanks" keeps what they picked and stops asking
  for that product this visit.

  Three ways in, so it works whatever built the page:
  1. Product forms (submit event). The page's own picker moves to Extrait and
     the theme's form adds it, so drawers and HOK+ behave as normal. The X
     cancels the add here.
  2. Bundle buy button (#nbb-final-atc) next to the HOK Fragrance Strength
     block. "Add to cart" picks Extrait in that block, then presses the button
     again, so the block adds its upgrade product as it always has.
  3. Everything else that posts to /cart/add through fetch or XMLHttpRequest
     (quiz, grids, landers, GemPages, apps). The request is held, the variant
     ids are swapped on "Add to cart", and the X counts as "continue".

  Skipped: carts with the drawer open (upsells inside it), subscription lines,
  the HOK+ membership line, and pages where a Kaching deal widget is showing.
  HOK+ buy-now adds (X-Hok-Membership header) are screened like any other,
  because they carry the shopper's own bottles.
  Any bottle outside the preloaded collection is checked once through
  /variants/<id>.js (about 0.3s) and cached for the visit. Only a perfume
  bottle goes on to fetch its product. If a check takes longer than 1.5s the
  add goes through untouched.
  Add ?xp_demo=1 to any page URL to open the popup without adding anything.

  Stats: every show, accept, decline and close is posted to the HOK dash
  (Theme settings > "Send popup stats"), with the time the shopper took to
  decide. The order is stamped too: cart attributes "Extrait popup" and
  "Extrait popup session", and a hidden _hok_xp property on the upgraded
  line, so the dash can tie what the popup did to what was actually paid.
  GA4 and the Meta pixel get an extrait_popup event when they are present.
*/
(function () {
  'use strict';
  if (window.__hokXpInit) return;
  var dataEl = document.getElementById('HokXpData');
  if (!dataEl) return;
  var CFG;
  try { CFG = JSON.parse(dataEl.textContent); } catch (err) { return; }
  window.__hokXpInit = true;

  var T = CFG.text || {};
  var KW = String(CFG.keyword || 'extrait').toLowerCase();
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var baseFetch = window.fetch ? window.fetch.bind(window) : null;
  var EXCLUDED = (CFG.memberExcluded || []).map(function (h) { return String(h).trim(); });
  /* Bundle pages (Khiz and Jai, 2026-10-01): the popup adds the strength
     box's own upgrade product, kept at its $20 price, and quotes the HOK+
     member price when the membership is going in. Checkout prints the $20
     line and takes the 10% off as the HOK+ order row. */
  var PCT = parseInt(CFG.memberPct, 10) || 0;
  function memberCents(c) { return c - Math.floor((c * PCT) / 100); }
  /* the HOK+ membership line is never a bottle, whoever sends it */
  var MEMBER_VID = parseInt(CFG.memberVariant, 10) || 0;
  try {
    var hokCfg = document.getElementById('HokMembershipConfig');
    if (hokCfg) MEMBER_VID = parseInt(JSON.parse(hokCfg.textContent).variantId, 10) || MEMBER_VID;
  } catch (err) {}

  /* Bundle pages: the flat-price upgrade product picked in Theme settings
     (e.g. $10). "Add to cart" adds it once per order in place of the strength
     block's own upgrade line. With nothing picked, bundle pages skip the popup,
     so it never quotes a price the cart would not charge. */
  var BUNDLE_UP = (CFG.bundleUpgrade && CFG.bundleUpgrade.vid && CFG.bundleUpgrade.available) ? CFG.bundleUpgrade : null;
  /* the regular price shown crossed out next to the offer (0 = none) */
  var WAS = parseInt(CFG.compare, 10) || 0;
  /* After "Add to cart" on a bundle page the popup owns the strength choice:
     the $10 product rides on every add until one succeeds, and the block's
     own $20 line stays off, until the shopper clicks a strength option
     themselves. A ten-second timer here let a refused-then-retried add ship
     Extrait bottles with no $10 line, and a second press after ten seconds
     ship the $20 line instead (orders on 2026-09-30). */
  var UP = { owned: false, inCart: false, wrap: null, upId: '' };
  function ownUpgrade(wrap) {
    UP.owned = true; UP.inCart = false; UP.wrap = wrap;
    var up = wrap.getAttribute('data-upgrade-id');
    /* Jai 2026-10-01: keep data-upgrade-id in place — the buy button, size cards and
       purchase options all read it to show the Extrait-inclusive totals. The strength
       block skips its own upgrade line while data-upgrade-owned is set (the popup
       injects the flat upgrade product itself). */
    if (up) { UP.upId = up; wrap.dataset.upgradeOwned = '1'; }
    if (!wrap.dataset.hokXpWatch) {
      wrap.dataset.hokXpWatch = '1';
      wrap.addEventListener('click', function (e) {
        if (!e.isTrusted || !e.target.closest || !e.target.closest('.hok-fsb__opt')) return;
        releaseUpgrade(); /* their own click: the block is in charge again */
      }, true);
    }
  }
  function releaseUpgrade() {
    if (!UP.owned) return;
    UP.owned = false; UP.inCart = false;
    if (UP.wrap) { delete UP.wrap.dataset.upgradeOwned; if (UP.upId && !UP.wrap.getAttribute('data-upgrade-id')) UP.wrap.setAttribute('data-upgrade-id', UP.upId); }
  }

  /* ---------- stats ---------- */
  var TRACK = CFG.track || {};
  var THEME = CFG.theme || {};
  var DEMO = /[?&]xp_demo=1(&|$)/.test(window.location.search);
  function lget(k) { try { return window.localStorage.getItem(k); } catch (err) { return null; } }
  function lset(k, v) { try { window.localStorage.setItem(k, v); } catch (err) {} }
  function rid() {
    var out = '';
    try {
      var a = new Uint8Array(8); window.crypto.getRandomValues(a);
      for (var n = 0; n < a.length; n++) out += ('0' + a[n].toString(16)).slice(-2);
    } catch (err) { out = Math.random().toString(16).slice(2, 10) + Math.random().toString(16).slice(2, 10); }
    return out;
  }
  /* one id per browser session (also stamped on the order), one per browser */
  var SID = sget('hokXpSid') || rid(); sset('hokXpSid', SID);
  var VISITOR = lget('hokXpVid') || rid(); lset('hokXpVid', VISITOR);
  var SEQ = 0;
  var ACCEPTED = null; /* the last accepted offer, until its add is confirmed */
  function device() { return window.innerWidth <= 640 ? 'mobile' : 'desktop'; }
  function offerCents(info) {
    if (!info) return 0;
    if (info.mode === 'bundle') return info.upPrice || 0;
    return (info.upPrice || 0) * (info.bottles || 1);
  }
  /* posts one event to the dash; text/plain keeps it a simple request, so no
     preflight, and sendBeacon survives the page leaving for checkout */
  function track(event, info, dwell) {
    if (!TRACK.on || !TRACK.url) return;
    var ev = {
      key: SID + ':' + (++SEQ) + ':' + now().toString(36),
      event: event,
      offer: 'extrait',
      sid: SID,
      visitor: VISITOR,
      sent_at: new Date().toISOString(),
      page: window.location.pathname,
      template: CFG.template || null,
      handle: info && info.handle || null,
      product_id: info && info.pid || null,
      variant_id: info && info.vid || null,
      path: info ? (info.mode === 'bundle' ? 'bundle' : 'swap') : null,
      bottles: info && info.bottles || null,
      price_cents: offerCents(info) || null,
      was_cents: info && info.upWas || null,
      currency: CFG.currency || null,
      country: CFG.country || null,
      device: device(),
      viewport_w: window.innerWidth,
      dwell_ms: dwell == null ? null : dwell,
      theme_id: THEME.id || null,
      theme_role: THEME.role || null,
      design: TRACK.design || null,
      demo: DEMO,
      referrer: (function () { try { return document.referrer ? new URL(document.referrer).host : null; } catch (err) { return null; } })()
    };
    var body = JSON.stringify(ev);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(TRACK.url, new Blob([body], { type: 'text/plain' }))) return;
    } catch (err) {}
    try {
      if (baseFetch) baseFetch(TRACK.url, { method: 'POST', mode: 'no-cors', credentials: 'omit', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body }).catch(function () {});
    } catch (err) {}
  }
  /* GA4 and Meta, when the page has them */
  function pixels(action, info) {
    if (TRACK.pixels === false) return;
    var dollars = Math.round(offerCents(info)) / 100;
    try { if (typeof window.gtag === 'function') window.gtag('event', 'extrait_popup', { popup_action: action, device: device(), value: dollars, currency: CFG.currency || undefined }); } catch (err) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'ExtraitPopup', { action: action, value: dollars, currency: CFG.currency || undefined }); } catch (err) {}
  }
  /* the order carries what the popup did: cart attributes, merged by Shopify */
  function stamp(state) {
    if (!TRACK.on || !baseFetch || DEMO) return;
    var attrs = { 'Extrait popup': state, 'Extrait popup session': SID };
    try {
      baseFetch(ROOT + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    } catch (err) {}
  }
  /* an add that the popup upgraded has landed in the cart */
  function confirmAdded(ok) {
    if (!ACCEPTED || ACCEPTED.until < now()) { ACCEPTED = null; return; }
    var a = ACCEPTED; ACCEPTED = null;
    if (ok) track('added', a.info, now() - a.at);
  }
  /* testing only: ?xp_debug=1&xp_up_test=<variant id> stands in any variant */
  (function () {
    var m = window.location.search.match(/[?&]xp_up_test=(\d+)/);
    if (!m || !/[?&]xp_debug=1(&|$)/.test(window.location.search) || !baseFetch) return;
    baseFetch(ROOT + 'variants/' + m[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (v) { BUNDLE_UP = { vid: v.id, price: v.price, available: true, test: true }; })
      .catch(function () {});
  })();

  function hasKw(s) { return String(s || '').toLowerCase().indexOf(KW) !== -1; }
  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function now() { return Date.now(); }

  /* ---------- visit memory ---------- */
  function sget(k) { try { return window.sessionStorage.getItem(k); } catch (err) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (err) {} }
  function saidNo(pid) { return sget('hokXpNo:' + pid) === '1'; }
  function rememberNo(pid) { if (pid) sset('hokXpNo:' + pid, '1'); }

  /* ---------- money in the store's own format ---------- */
  var FMT = (function (sample) {
    /* the store's money format can wrap amounts in <span class=money>, so keep
       only the visible text (tags stripped, entities like &#36; decoded) */
    var s = String(sample || '').replace(/<[^>]*>/g, '');
    try { var ta = document.createElement('textarea'); ta.innerHTML = s; s = ta.value; } catch (err) {}
    s = s.replace(/\u00a0/g, ' ').trim();
    var m = s.match(/^([^0-9]*)1([^0-9]?)234([^0-9])56([^0-9]*)$/);
    return m ? { pre: m[1], thou: m[2], dec: m[3], post: m[4] } : null;
  })(CFG.moneySample);
  function money(cents) {
    cents = Math.round(cents) || 0;
    var neg = cents < 0;
    cents = Math.abs(cents);
    if (FMT) {
      var whole = String(Math.floor(cents / 100));
      var dec = String(cents % 100);
      if (dec.length < 2) dec = '0' + dec;
      if (FMT.thou) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, FMT.thou);
      return (neg ? '-' : '') + FMT.pre + whole + FMT.dec + dec + FMT.post;
    }
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return (neg ? '-' : '') + new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (err) { return (neg ? '-$' : '$') + (cents / 100).toFixed(2); }
  }

  /* ---------- product index ---------- */
  var PRODUCTS = {};
  var VARS = {};
  function addProduct(p) {
    if (!p || !p.pid) return null;
    PRODUCTS[p.pid] = p;
    (p.vars || []).forEach(function (v) { VARS[v.id] = { prod: p, v: v }; });
    return p;
  }
  (CFG.products || []).forEach(function (p) { if (p) addProduct(p); });

  function strengthIndex(vars) {
    for (var n = 0; n < vars.length; n++) {
      for (var i = 0; i < vars[n].o.length; i++) if (hasKw(vars[n].o[i])) return i;
    }
    return -1;
  }
  function sized(url) {
    if (!url) return null;
    url = String(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }
  function fromProductJs(pj) {
    var vars = (pj.variants || []).map(function (v) {
      return {
        id: v.id,
        o: v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }),
        p: v.price,
        a: !!v.available,
        img: v.featured_image ? sized(v.featured_image.src) : null
      };
    });
    var tags = (pj.tags || []).map(function (t) { return String(t).toLowerCase().trim(); });
    var off = EXCLUDED.indexOf(pj.handle) !== -1 || tags.indexOf('no-hok-plus') !== -1;
    return {
      pid: pj.id,
      handle: pj.handle,
      opt: strengthIndex(vars),
      member: !!CFG.member && !off,
      img: sized(pj.featured_image),
      vars: vars
    };
  }

  function twinOf(entry) {
    if (!entry) return null;
    var p = entry.prod, v = entry.v, i = p.opt;
    if (i < 0 || hasKw(v.o[i])) return null;
    for (var n = 0; n < p.vars.length; n++) {
      var w = p.vars[n];
      if (w.id === v.id || !w.a || !hasKw(w.o[i])) continue;
      var same = true;
      for (var k = 0; k < w.o.length; k++) {
        if (k !== i && w.o[k] !== v.o[k]) { same = false; break; }
      }
      if (same) return w;
    }
    return null;
  }

  /* Any variant id -> its product, cached for the visit. */
  var inflight = {};
  function lookup(vid) {
    vid = parseInt(vid, 10);
    if (!vid) return Promise.resolve(null);
    if (VARS[vid]) return Promise.resolve(VARS[vid]);
    var memo = sget('hokXpVar:' + vid);
    if (memo === 'none') return Promise.resolve(null);
    if (memo && memo.indexOf('p:') === 0) {
      try {
        var saved = JSON.parse(sget('hokXpProd:' + memo.slice(2)) || 'null');
        if (saved && addProduct(saved) && VARS[vid]) return Promise.resolve(VARS[vid]);
      } catch (err) {}
    }
    if (inflight[vid]) return inflight[vid];
    if (!baseFetch) return Promise.resolve(null);
    var opts = { credentials: 'same-origin' };
    var json = function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); };
    var none = function () { sset('hokXpVar:' + vid, 'none'); return null; };
    var keep = function (pj) {
      var p = addProduct(fromProductJs(pj));
      if (p.opt >= 0) sset('hokXpProd:' + p.pid, JSON.stringify(p));
      p.vars.forEach(function (v) { sset('hokXpVar:' + v.id, p.opt >= 0 ? 'p:' + p.pid : 'none'); });
      return VARS[vid] || none();
    };
    /* 1. The variant alone (fast). Anything that is not a perfume bottle, or
          is already Extrait, stops here. */
    inflight[vid] = baseFetch(ROOT + 'variants/' + vid + '.js', opts)
      .then(json)
      .then(function (v) {
        var o = v.options || [v.option1, v.option2, v.option3];
        var bottle = o.some(function (x) { return SCENT_RE.test(String(x || '')); });
        if (!bottle || o.some(hasKw)) return none();
        /* 2. A perfume bottle outside the preloaded list: fetch its product,
              trying the handle its name suggests before the slower redirect. */
        var guess = slug(String(v.name || '').split(' - ')[0]);
        var viaRedirect = function () {
          return baseFetch(ROOT + 'variants/' + vid, { method: 'HEAD', credentials: 'same-origin' })
            .then(function (r) {
              var m = String(r.url || '').match(/\/products\/([^\/?#]+)/);
              if (!m) throw new Error('no product');
              return baseFetch(ROOT + 'products/' + m[1] + '.js', opts).then(json);
            });
        };
        var first = guess ? baseFetch(ROOT + 'products/' + guess + '.js', opts).then(json).then(function (pj) {
          var mine = (pj.variants || []).some(function (x) { return x.id === vid; });
          return mine ? pj : viaRedirect();
        }, viaRedirect) : viaRedirect();
        return first.then(keep);
      })
      .catch(function () { return null; });
    return inflight[vid];
  }
  var SCENT_RE = /parfum|toilette|cologne|\bedp\b|\bedt\b/i;
  function slug(s) {
    s = String(s || '');
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (err) {}
    return s.toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* ---------- when to stay out of the way ---------- */
  function drawerOpen() { return !!document.querySelector('cart-drawer.active, cart-drawer[open]'); }
  function kachingInCharge() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    for (var n = 0; n < bars.length; n++) if (bars[n].offsetParent !== null) return true;
    return false;
  }
  var PASS_UNTIL = 0;   /* a path below already asked, let its own add through */
  var RECENT = null;    /* last answer, reused for follow-up adds for 4 seconds */

  /* ---------- the popup ---------- */
  var CSS =
    '.hok-xp{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;justify-content:center;padding:16px;-webkit-tap-highlight-color:transparent}' +
    '.hok-xp[hidden]{display:none}' +
    /* resting state is fully visible, the keyframes only play the entrance */
    '.hok-xp .hok-xp__backdrop{display:block;position:absolute;inset:0;background:rgba(18,18,18,.55)}' +
    '.hok-xp .hok-xp__panel{position:relative;box-sizing:border-box;width:100%;max-width:400px;max-height:calc(100vh - 32px);overflow-y:auto;overscroll-behavior:contain;background:#fff;color:#121212;border-radius:14px;padding:24px 20px 18px;box-shadow:0 24px 60px rgba(0,0,0,.25);font-family:inherit;text-align:left}' +
    '.hok-xp.is-open .hok-xp__backdrop{animation:hokXpFade .2s ease both}' +
    '.hok-xp.is-open .hok-xp__panel{animation:hokXpUp .22s ease both}' +
    '@keyframes hokXpFade{from{opacity:0}to{opacity:1}}' +
    '@keyframes hokXpUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}' +
    '@keyframes hokXpSheet{from{transform:translateY(100%)}to{transform:none}}' +
    '.hok-xp .hok-xp__x{position:absolute;top:6px;right:6px;z-index:2;width:34px;height:34px;display:flex;align-items:center;justify-content:center;padding:0;margin:0;border:0;border-radius:50%;background:transparent;color:#6b6b6b;cursor:pointer;box-shadow:none}' +
    '.hok-xp .hok-xp__x:hover{background:#f4f1ec;color:#121212}' +
    '.hok-xp .hok-xp__x svg{width:16px;height:16px;display:block}' +
    '.hok-xp .hok-xp__grid{display:block}' +
    '.hok-xp .hok-xp__visual{display:grid;grid-template-columns:minmax(0,1.2fr) minmax(0,1fr);gap:16px;align-items:center;margin:0 0 18px}' +
    /* left: the graphic, built from the real product photo */
    '.hok-xp .hok-xp__stage{position:relative;display:flex;align-items:center;justify-content:center;aspect-ratio:4/5;background:#f6f3ee;border-radius:12px}' +
    '.hok-xp .hok-xp__hero{display:block;width:100%;height:100%;object-fit:cover;border-radius:12px}' +
    '.hok-xp .hok-xp__hero[hidden]{display:none}' +
    '.hok-xp .hok-xp__badge{position:absolute;top:-10px;right:-10px;box-sizing:border-box;width:82px;height:82px;padding:8px;border-radius:50%;background:#B17743;color:#fff;display:flex;align-items:center;justify-content:center;text-align:center;font-size:11px;font-weight:800;line-height:1.15;letter-spacing:.04em;text-transform:uppercase;box-shadow:0 8px 20px rgba(177,119,67,.35)}' +
    '.hok-xp .hok-xp__badge[hidden]{display:none}' +
    '.hok-xp .hok-xp__bars{display:grid;gap:18px;margin:0}' +
    '.hok-xp .hok-xp__mtag{display:none}' +
    '.hok-xp .hok-xp__rowhead{display:grid;grid-template-columns:auto minmax(0,1fr);grid-template-areas:"label label" "hrs oil";column-gap:8px;row-gap:3px;align-items:baseline;margin-bottom:8px}' +
    '.hok-xp .hok-xp__label{grid-area:label;font-size:12px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#6b6b6b}' +
    '.hok-xp .hok-xp__row--b .hok-xp__label{color:#96601f}' +
    '.hok-xp .hok-xp__oil{grid-area:oil;font-size:12px;font-weight:600;color:#8a8a8a}' +
    '.hok-xp .hok-xp__oil:empty{display:none}' +
    '.hok-xp .hok-xp__hrs{grid-area:hrs;font-size:28px;font-weight:800;line-height:1;color:#6b6b6b}' +
    '.hok-xp .hok-xp__row--b .hok-xp__hrs{color:#B17743}' +
    '.hok-xp .hok-xp__bar{display:block;height:10px;border-radius:99px;background:#ece7df;overflow:hidden}' +
    '.hok-xp .hok-xp__fill{display:block;height:100%;border-radius:99px;background:#b9b3a9}' +
    '.hok-xp .hok-xp__row--b .hok-xp__fill{background:#B17743}' +
    /* right: the words, the offer, the buttons */
    '.hok-xp .hok-xp__head{display:flex;align-items:center;gap:14px;margin:0 0 10px}' +
    '.hok-xp .hok-xp__img{display:none;flex:none;width:56px;height:56px;object-fit:cover;border-radius:10px;background:#f4f1ec}' +
    '.hok-xp .hok-xp__pill{display:inline-flex;align-items:center;gap:5px;margin:0 0 8px;padding:4px 8px;border-radius:4px;background:#121212;color:#fff;font-size:11.5px;font-weight:700;line-height:1.2;letter-spacing:.2px}' +
    '.hok-xp .hok-xp__pill[hidden]{display:none}' +
    '.hok-xp .hok-xp__pill svg{width:12px;height:12px;display:block;flex:none}' +
    '.hok-xp .hok-xp__title{margin:0;font-size:22px;line-height:1.15;font-weight:700!important;letter-spacing:-.01em;color:#121212}' +
    '.hok-xp .hok-xp__lead{display:block;margin:0 0 10px;font-size:15px;font-weight:700!important;line-height:1.35;color:#121212}' +
    '.hok-xp .hok-xp__lead[hidden]{display:none}' +
    '.hok-xp .hok-xp__list{list-style:none;margin:0 0 18px;padding:0;display:grid;gap:9px}' +
    '.hok-xp .hok-xp__list[hidden]{display:none}' +
    '.hok-xp .hok-xp__list li{display:flex;align-items:flex-start;gap:9px;margin:0;padding:0;font-size:15px;line-height:1.35;color:#333}' +
    '.hok-xp .hok-xp__list li::before,.hok-xp .hok-xp__list li::marker{content:none}' +
    '.hok-xp .hok-xp__list svg{flex:none;width:18px;height:18px;margin-top:1px;display:block}' +
    '.hok-xp .hok-xp__deal{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:10px 12px;margin:0 0 14px}' +
    '.hok-xp .hok-xp__deal[hidden]{display:none}' +
    '.hok-xp .hok-xp__tag{display:inline-block;padding:5px 9px;border-radius:6px;background:#B17743;color:#fff;font-size:12px;font-weight:800;line-height:1;letter-spacing:.06em;text-transform:uppercase}' +
    '.hok-xp .hok-xp__tag[hidden]{display:none}' +
    '.hok-xp .hok-xp__now{font-size:30px;font-weight:800;line-height:1;color:#121212;letter-spacing:-.01em}' +
    '.hok-xp .hok-xp__was{font-size:17px;font-weight:600;color:#8a8a8a;text-decoration:line-through}' +
    '.hok-xp .hok-xp__was[hidden]{display:none}' +
    '.hok-xp .hok-xp__yes{display:block;box-sizing:border-box;width:100%;margin:0;padding:16px 18px;border:0;border-radius:12px;background:#B17743;color:#fff;font-family:inherit;font-size:15px;font-weight:800;line-height:1.2;letter-spacing:.5px;text-transform:uppercase;cursor:pointer;box-shadow:0 6px 16px rgba(177,119,67,.35);transition:background-color .2s ease}' +
    '.hok-xp .hok-xp__yes:hover{background:#9c6737}' +
    '.hok-xp .hok-xp__no{display:block;box-sizing:border-box;width:100%;margin:6px 0 0;padding:12px 10px;border:0;background:transparent;color:#555;font-family:inherit;font-size:13.5px;line-height:1.3;text-decoration:underline;text-underline-offset:3px;cursor:pointer;box-shadow:none}' +
    '.hok-xp .hok-xp__no:hover{color:#121212;background:transparent}' +
    '.hok-xp .hok-xp__yes:focus-visible,.hok-xp .hok-xp__no:focus-visible,.hok-xp .hok-xp__x:focus-visible{outline:2px solid #121212;outline-offset:2px}' +
    /* phones: bottom sheet with the same order as desktop */
    '@media (max-width:640px){' +
      '.hok-xp{align-items:flex-end;padding:0}' +
      '.hok-xp .hok-xp__panel{max-width:none;max-height:92vh;border-radius:18px 18px 0 0;padding:20px 16px calc(12px + env(safe-area-inset-bottom))}' +
      '.hok-xp.is-open .hok-xp__panel{animation-name:hokXpSheet}' +
      '.hok-xp .hok-xp__visual{gap:14px;margin-bottom:16px}' +
      '.hok-xp .hok-xp__badge{width:70px;height:70px;padding:6px;font-size:10px;top:-8px;right:-8px}' +
      '.hok-xp .hok-xp__bars{gap:14px}' +
      '.hok-xp .hok-xp__hrs{font-size:24px}' +
      '.hok-xp .hok-xp__label,.hok-xp .hok-xp__oil{font-size:11px}' +
      '.hok-xp .hok-xp__bar{height:8px}' +
      '.hok-xp .hok-xp__head{margin:0 0 10px}' +
      '.hok-xp .hok-xp__title{font-size:20px}' +
      '.hok-xp .hok-xp__lead{font-size:14px}' +
      '.hok-xp .hok-xp__list{margin-bottom:14px}' +
      '.hok-xp .hok-xp__list li{font-size:13.5px}' +
      '.hok-xp .hok-xp__deal{margin-bottom:12px}' +
      '.hok-xp .hok-xp__now{font-size:26px}' +
    '}' +
    '@media (min-width:641px) and (max-height:760px){' +
      '.hok-xp .hok-xp__panel{padding:20px 20px 14px}' +
      '.hok-xp .hok-xp__stage{aspect-ratio:1/1}' +
      '.hok-xp .hok-xp__visual{margin-bottom:14px}' +
      '.hok-xp .hok-xp__bars{gap:14px}' +
      '.hok-xp .hok-xp__hrs{font-size:24px}' +
      '.hok-xp .hok-xp__head{margin-bottom:8px}' +
      '.hok-xp .hok-xp__title{font-size:21px}' +
      '.hok-xp .hok-xp__lead{margin-bottom:8px}' +
      '.hok-xp .hok-xp__list{gap:7px;margin-bottom:14px}' +
      '.hok-xp .hok-xp__deal{margin-bottom:10px}' +
      '.hok-xp .hok-xp__yes{padding:14px 18px}' +
      '.hok-xp .hok-xp__no{padding:10px}' +
    '}' +
    '@media (prefers-reduced-motion:reduce){.hok-xp.is-open .hok-xp__backdrop,.hok-xp.is-open .hok-xp__panel{animation:none}}';

  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#FFC53D" d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4-4.7-4.4 6.4-.8z"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#B17743"/><path d="M5.8 10.3l2.7 2.7 5.7-5.9" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var root = null, current = null, lastFocus = null;

  function build() {
    if (root) return root;
    var st = document.createElement('style');
    st.id = 'HokXpStyle';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);

    root = document.createElement('div');
    root.className = 'hok-xp';
    root.hidden = true;
    root.innerHTML =
      '<div class="hok-xp__backdrop" data-xp-close></div>' +
      '<div class="hok-xp__panel" role="dialog" aria-modal="true" aria-labelledby="HokXpTitle">' +
        '<button type="button" class="hok-xp__x" data-xp-close aria-label="Close">' + ICON_X + '</button>' +
        '<div class="hok-xp__grid">' +
          '<div class="hok-xp__visual">' +
            '<div class="hok-xp__stage">' +
              '<img class="hok-xp__hero" data-xp="hero" alt="" hidden>' +
              '<span class="hok-xp__badge" data-xp="badge" hidden></span>' +
            '</div>' +
            '<div class="hok-xp__bars" data-xp="bars">' +
              '<span class="hok-xp__mtag" data-xp="mtag" hidden></span>' +
              '<div class="hok-xp__row hok-xp__row--a">' +
                '<div class="hok-xp__rowhead"><span class="hok-xp__label" data-xp="labelA"></span><span class="hok-xp__oil" data-xp="oilA"></span><span class="hok-xp__hrs" data-xp="hoursA"></span></div>' +
                '<span class="hok-xp__bar"><span class="hok-xp__fill" data-xp="fillA"></span></span>' +
              '</div>' +
              '<div class="hok-xp__row hok-xp__row--b">' +
                '<div class="hok-xp__rowhead"><span class="hok-xp__label" data-xp="labelB"></span><span class="hok-xp__oil" data-xp="oilB"></span><span class="hok-xp__hrs" data-xp="hoursB"></span></div>' +
                '<span class="hok-xp__bar"><span class="hok-xp__fill" data-xp="fillB"></span></span>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="hok-xp__body">' +
            '<div class="hok-xp__head">' +
              '<img class="hok-xp__img" data-xp="thumb" alt="" width="56" height="56" hidden>' +
              '<div>' +
                '<span class="hok-xp__pill" data-xp="pill">' + ICON_STAR + '<span data-xp="rating"></span></span>' +
                '<p class="hok-xp__title" id="HokXpTitle" data-xp="title"></p>' +
              '</div>' +
            '</div>' +
            '<div class="hok-xp__lead" data-xp="lead" hidden></div>' +
            '<ul class="hok-xp__list" data-xp="list"></ul>' +
            '<div class="hok-xp__deal" data-xp="deal" hidden>' +
              '<span class="hok-xp__tag" data-xp="tag" hidden></span>' +
              '<span class="hok-xp__now" data-xp="now"></span>' +
              '<s class="hok-xp__was" data-xp="was" hidden></s>' +
            '</div>' +
            '<button type="button" class="hok-xp__yes" data-xp-yes></button>' +
            '<button type="button" class="hok-xp__no" data-xp-no></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-xp-yes]')) finish('yes');
      else if (e.target.closest('[data-xp-no]')) finish('no');
      else if (e.target.closest('[data-xp-close]')) finish('close');
    });
    document.addEventListener('keydown', function (e) {
      if (!current) return;
      if (e.key === 'Escape') { e.preventDefault(); finish('close'); return; }
      if (e.key === 'Tab') {
        var f = Array.prototype.slice.call(root.querySelectorAll('button'));
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted && current) finish('close'); });
    return root;
  }

  function el(key) { return root.querySelector('[data-xp="' + key + '"]'); }
  function fill(str, info) {
    return String(str || '')
      .split('[price]').join(info.diff || '')
      .split('[current]').join(info.nameA || '')
      .split('[upgrade]').join(info.nameB || '');
  }
  function hoursNum(s) {
    var m = String(s || '').match(/\d+(\.\d+)?/g);
    return m ? Math.max.apply(null, m.map(parseFloat)) : 0;
  }

  function render(info) {
    var hero = el('hero'), thumb = el('thumb');
    if (info.image) {
      hero.src = String(info.image).replace(/([?&])width=240(?=&|$)/, '$1width=600'); hero.hidden = false;
      thumb.src = info.image; thumb.hidden = false;
    } else {
      hero.removeAttribute('src'); hero.hidden = true;
      thumb.removeAttribute('src'); thumb.hidden = true;
    }

    el('rating').textContent = T.rating || '';
    el('pill').hidden = !T.rating;
    el('title').textContent = fill(T.heading || 'Upgrade to Extrait de Parfum?', info);

    var lead = el('lead');
    lead.textContent = clean(fill(T.lead || '', info));
    lead.hidden = !lead.textContent;

    var list = el('list');
    list.innerHTML = '';
    (T.bullets || []).forEach(function (line) {
      line = clean(fill(line, info));
      if (!line) return;
      var li = document.createElement('li');
      li.innerHTML = ICON_CHECK;
      li.appendChild(document.createTextNode(line));
      list.appendChild(li);
    });
    list.hidden = !list.children.length;

    /* the graphic: badge on the photo (desktop), tag above the bars (phones) */
    el('badge').textContent = T.badge || '';
    el('badge').hidden = !T.badge;
    el('mtag').textContent = T.badge || '';
    el('mtag').hidden = !T.badge;
    el('labelA').textContent = T.labelA || info.nameA || '';
    el('labelB').textContent = T.labelB || info.nameB || '';
    el('oilA').textContent = T.oilA || '';
    el('oilB').textContent = T.oilB || '';
    var hA = hoursNum(T.hoursA), hB = hoursNum(T.hoursB);
    var top = Math.max(hA, hB) || 1;
    el('hoursA').textContent = T.hoursA || '';
    el('hoursB').textContent = T.hoursB || '';
    el('fillA').style.width = (hA ? Math.max(8, Math.round((hA / top) * 100)) : 50) + '%';
    el('fillB').style.width = (hB ? Math.max(8, Math.round((hB / top) * 100)) : 100) + '%';

    /* the offer: price, the crossed-out original, the percent tag */
    var deal = el('deal'), was = el('was'), tag = el('tag');
    var nowCents = info.upPrice > 0 ? info.upPrice : 0;
    if (nowCents || info.upText) {
      el('now').textContent = info.upText || money(nowCents);
      var wasCents = info.upWas > nowCents ? info.upWas : 0;
      was.textContent = wasCents ? money(wasCents) : '';
      was.hidden = !wasCents;
      var pct = (wasCents && nowCents) ? Math.round(((wasCents - nowCents) / wasCents) * 100) : 0;
      tag.textContent = pct > 0 ? String(T.tag || '[pct]% OFF').split('[pct]').join(String(pct)) : '';
      tag.hidden = !tag.textContent;
      deal.hidden = false;
    } else {
      deal.hidden = true;
    }

    root.querySelector('[data-xp-yes]').textContent = fill(T.yes || 'Add to cart', info);
    root.querySelector('[data-xp-no]').textContent = fill(T.no || 'No thanks, continue', info);
  }

  function ask(info) {
    if (current) return Promise.resolve('close');
    build();
    return new Promise(function (resolve) {
      current = { info: info, resolve: resolve, openedAt: now() };
      render(info);
      lastFocus = document.activeElement;
      root.hidden = false;
      void root.offsetWidth; /* start the fade from the hidden state */
      root.classList.add('is-open');
      try { root.querySelector('[data-xp-yes]').focus({ preventScroll: true }); } catch (err) {}
      stamp('shown');
      track('shown', info, null);
      pixels('shown', info);
      emit('shown', info);
    });
  }

  function finish(choice) {
    if (!current) return;
    var c = current;
    current = null;
    root.classList.remove('is-open');
    root.hidden = true;
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (err) {}
    }
    RECENT = { value: choice, until: now() + 4000 };
    var dwell = now() - (c.openedAt || now());
    var state = choice === 'yes' ? 'accepted' : choice === 'no' ? 'declined' : 'closed';
    if (choice === 'yes') ACCEPTED = { info: c.info, at: now(), until: now() + 15000 };
    stamp(state);            /* first, so it is on its way before the add */
    track(state, c.info, dwell);
    pixels(state, c.info);
    emit(choice === 'yes' ? 'upgrade' : choice === 'no' ? 'decline' : 'close', c.info);
    c.resolve(choice);
  }

  function emit(action, info) {
    try {
      document.dispatchEvent(new CustomEvent('hok:extrait-popup', {
        detail: { action: action, mode: info ? info.mode : null, product: info ? info.pid : null }
      }));
    } catch (err) {}
  }

  /* Card and price text for an Eau de Parfum -> Extrait swap. */
  function swapInfo(mode, pairs) {
    var first = pairs[0];
    var p = first.entry.prod, i = p.opt;
    var per = first.to.p - first.entry.v.p;
    var bottles = 0;
    pairs.forEach(function (x) { bottles += (x.qty || 1); });
    var shown = per > 0 ? money(per) + (bottles > 1 ? ' each' : '') : '';
    return {
      mode: mode,
      pid: p.pid,
      handle: p.handle || null,
      vid: first.to.id,
      bottles: bottles,
      nameA: first.entry.v.o[i],
      nameB: first.to.o[i],
      priceA: '',
      priceB: '',
      upPrice: per > 0 ? per : 0,
      upWas: WAS,
      upText: (per > 0 && bottles > 1) ? shown : '',
      diff: shown,
      image: first.to.img || first.entry.v.img || p.img || null
    };
  }

  /* ---------- 1. product forms ---------- */
  function sel(id) { return (window.CSS && window.CSS.escape) ? window.CSS.escape(id) : id; }
  function field(form, name) {
    var f = form.querySelector('[name="' + name + '"]');
    var fid = form.getAttribute('id');
    if (!f && fid) f = document.querySelector('[name="' + name + '"][form="' + sel(fid) + '"]');
    return f;
  }

  function switchVariant(form, entry, to) {
    var i = entry.prod.opt;
    var from = entry.v.o[i], want = to.o[i];
    var radios = Array.prototype.filter.call(form.elements || [], function (x) { return x.type === 'radio'; });
    radios.forEach(function (r) {
      if (r.value !== want || r.checked || r.disabled) return;
      var group = radios.filter(function (x) { return x.name === r.name; });
      var isStrength = group.some(function (x) { return x.value === from; });
      if (!isStrength) return;
      r.checked = true;
      r.dispatchEvent(new Event('input', { bubbles: true }));
      r.dispatchEvent(new Event('change', { bubbles: true }));
    });
    var idIn = field(form, 'id');
    if (idIn) { idIn.disabled = false; idIn.value = String(to.id); }
  }

  /* a hidden property on the upgraded line, gone again after this submit */
  function markLine(form) {
    if (!TRACK.on) return;
    var inp = document.createElement('input');
    inp.type = 'hidden'; inp.name = 'properties[_hok_xp]'; inp.value = 'accepted';
    form.appendChild(inp);
    setTimeout(function () { if (inp.parentNode) inp.parentNode.removeChild(inp); }, 1500);
  }

  function resubmit(form, btn) {
    form.dataset.hokXpPass = '1';
    PASS_UNTIL = now() + 5000;
    try {
      if (typeof form.requestSubmit === 'function') {
        if (btn && btn.form === form && btn.type === 'submit') form.requestSubmit(btn);
        else form.requestSubmit();
      } else if (btn) {
        btn.click();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    } finally {
      delete form.dataset.hokXpPass;
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM' || e.defaultPrevented) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (form.dataset.hokXpPass === '1') return;
    if (drawerOpen() || kachingInCharge()) return;
    var idIn = field(form, 'id');
    if (!idIn) return;
    var entry = VARS[parseInt(idIn.value, 10)];
    var to = twinOf(entry);
    if (!to || saidNo(entry.prod.pid)) return;
    var plan = field(form, 'selling_plan');
    if (plan && plan.value) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = e.submitter || form.querySelector('[type="submit"]');
    var qEl = field(form, 'quantity');
    var qty = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
    var carryOn = function () { try { resubmit(form, btn); } catch (err) {} };
    var asked;
    try { asked = ask(swapInfo('form', [{ entry: entry, to: to, qty: qty }])); }
    catch (err) { carryOn(); return; }
    asked.then(function (choice) {
      if (choice === 'close') return; /* X, Escape, backdrop: nothing added */
      if (choice === 'no') rememberNo(entry.prod.pid);
      if (choice === 'yes') {
        try { switchVariant(form, entry, to); } catch (err) {}
        try { markLine(form); } catch (err) {}
      }
      carryOn();
    }, carryOn);
  }, true);

  /* ---------- 2. bundle buy button with the strength block ---------- */
  function optText(opt, cls) {
    var n = opt && opt.querySelector(cls);
    if (!n) return '';
    return String(n.innerText || n.textContent || '').split(/\s*\n+\s*/).map(clean).filter(Boolean).join(' · ');
  }

  document.addEventListener('click', function (e) {
    /* the bundle button, and the "buy once" buttons beside it that run the same add */
    var b = e.target && e.target.closest ? e.target.closest('#nbb-final-atc, .hok-dcta__once') : null;
    if (!b || e.defaultPrevented) return;
    if (b.dataset.hokXpPass === '1') return;
    if (b.disabled || b.classList.contains('disabled') || b.classList.contains('is-loading')) return;
    var wrap = document.querySelector('.hok-fsb');
    if (!wrap) return;
    var xOpt = null, aOpt = null;
    wrap.querySelectorAll('.hok-fsb__opt').forEach(function (o) {
      if (hasKw(o.dataset.value)) { if (!xOpt) xOpt = o; }
      else if (!aOpt) aOpt = o;
    });
    if (!xOpt || !aOpt) return;
    var pid = CFG.current || 'bundle';
    if (xOpt.classList.contains('is-active') || hasKw(window.__hokStrength) || saidNo(pid)) {
      PASS_UNTIL = now() + 5000; /* the strength block already decided */
      return;
    }

    if (!BUNDLE_UP) {
      PASS_UNTIL = now() + 5000; /* no flat upgrade picked: leave bundles as they are */
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var cur = CFG.current && PRODUCTS[CFG.current];
    /* The member price when the membership is going in
       (same rule as the strength box: membership on, not bundleog, not buy
       once, not opted out), else the full price. */
    var showUp = BUNDLE_UP.price;
    try {
      var memberIn = !!CFG.member && PCT > 0 && !/bundleog/.test(String(CFG.template || '')) &&
        window.__hokPurchaseMode !== 'once' && sget('hok_plus_opt_out') !== '1';
      if (memberIn && memberCents(showUp) < showUp) showUp = memberCents(showUp);
    } catch (err) {}
    /* Regular price is per bottle (Theme settings, $10). The flat upgrade
       covers the whole bundle, so the crossed-out price is bottles x regular
       and the tag is the saving: 3 bottles -> $30 struck, SAVE 33%; 4 -> $40,
       SAVE 50%. Fewer bottles than that saves nothing, so no strike. */
    var bottles = 0, regular = 0, wasUp = showUp < BUNDLE_UP.price ? BUNDLE_UP.price : WAS;
    try {
      document.querySelectorAll('.js-bundle-product').forEach(function (r) { bottles += parseInt(r.getAttribute('data-qty') || '0', 10) || 0; });
      if (!bottles) bottles = parseInt(window.__hokTarget, 10) || 0;
      regular = (parseInt(CFG.perBottle, 10) || 0) * bottles;
      if (regular > showUp) wasUp = regular;
    } catch (err) {}
    var pressAgain = function () {
      PASS_UNTIL = now() + 5000;
      b.dataset.hokXpPass = '1';
      try { b.click(); } finally { delete b.dataset.hokXpPass; }
    };
    var askedB;
    try { askedB = ask({
      mode: 'bundle',
      pid: pid,
      handle: cur ? cur.handle : null,
      vid: BUNDLE_UP.vid,
      nameA: aOpt.dataset.value,
      nameB: xOpt.dataset.value,
      priceA: '',
      priceB: '',
      upPrice: showUp,
      upWas: wasUp,
      upText: '',
      bottles: bottles || null,
      diff: money(showUp),
      image: cur ? cur.img : null
    }); } catch (err) { pressAgain(); return; }
    askedB.then(function (choice) {
      if (choice === 'close') return;
      if (choice === 'no') rememberNo(pid);
      if (choice === 'yes') {
        try {
          /* the strength block marks the bottles Extrait, the flat upgrade
             product replaces its own upgrade line */
          ownUpgrade(wrap);
          xOpt.click();
        } catch (err) {}
        /* Jai 2026-10-01: the strength switch re-prices the buy button, the size
           cards and the purchase options ~0.3-1s later (hok:strength → price
           sync). Pressing the button in the same tick meant the shopper never
           saw the new total before the drawer/checkout. Give the prices a
           moment to paint, then continue the add. */
        setTimeout(pressAgain, 600); /* prices repaint in ~0.3-0.5 s; Jai 2026-10-01: 1.4 s felt slow */
        return;
      }
      pressAgain();
    }, pressAgain);
  }, true);

  /* ---------- 3. every other add: fetch and XMLHttpRequest ---------- */
  function paramItems(sp) {
    var out = [];
    if (sp.has('id')) {
      out.push({
        id: parseInt(sp.get('id'), 10),
        qty: parseInt(sp.get('quantity'), 10) || 1,
        plan: sp.get('selling_plan'),
        auto: sp.get('properties[_hok_auto_added]'),
        set: function (nid) { sp.set('id', String(nid)); },
        prop: function (k, v) { sp.set('properties[' + k + ']', v); }
      });
    }
    var keys = [];
    sp.forEach(function (v, k) { if (/^items\[\d+\]\[id\]$/.test(k)) keys.push(k); });
    keys.forEach(function (k) {
      var pre = k.slice(0, k.length - 4);
      out.push({
        id: parseInt(sp.get(k), 10),
        qty: parseInt(sp.get(pre + '[quantity]'), 10) || 1,
        plan: sp.get(pre + '[selling_plan]'),
        auto: sp.get(pre + '[properties][_hok_auto_added]'),
        set: function (nid) { sp.set(k, String(nid)); },
        prop: function (pk, v) { sp.set(pre + '[properties][' + pk + ']', v); }
      });
    });
    return out;
  }

  function parseBody(body) {
    if (typeof body === 'string') {
      var s = body.trim();
      if (s.charAt(0) === '{') {
        var obj;
        try { obj = JSON.parse(s); } catch (err) { return null; }
        var list = Array.isArray(obj.items) ? obj.items : (obj.id != null ? [obj] : []);
        return {
          items: list.map(function (it) {
            return {
              id: parseInt(it.id, 10),
              qty: parseInt(it.quantity, 10) || 1,
              plan: it.selling_plan,
              auto: it.properties && it.properties._hok_auto_added,
              set: function (nid) { it.id = nid; },
              prop: function (k, v) { it.properties = it.properties || {}; it.properties[k] = v; }
            };
          }),
          out: function () { return JSON.stringify(obj); }
        };
      }
      var sp = new URLSearchParams(s);
      return { items: paramItems(sp), out: function () { return sp.toString(); } };
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return { items: paramItems(body), out: function () { return body; } };
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return { items: paramItems(body), out: function () { return body; } };
    }
    return null;
  }

  function screen(body) {
    if (now() < PASS_UNTIL) return Promise.resolve(body);
    var parsed;
    try { parsed = parseBody(body); } catch (err) { parsed = null; }
    if (!parsed || !parsed.items.length) return Promise.resolve(body);
    if (drawerOpen() || kachingInCharge()) return Promise.resolve(body);
    var cand = parsed.items.filter(function (it) { return it.id && it.id !== MEMBER_VID && !it.plan && !it.auto; });
    if (!cand.length) return Promise.resolve(body);

    var timer;
    var slow = new Promise(function (res) { timer = setTimeout(function () { res('slow'); }, 1500); });
    var work = Promise.all(cand.map(function (it) { return lookup(it.id); }));
    return Promise.race([work, slow]).then(function (found) {
      clearTimeout(timer);
      if (found === 'slow') return body;
      var pairs = [];
      cand.forEach(function (it, n) {
        var entry = found[n];
        var to = twinOf(entry);
        if (to && !saidNo(entry.prod.pid)) pairs.push({ it: it, entry: entry, to: to, qty: it.qty });
      });
      if (!pairs.length) return body;
      var upgrade = function () {
        pairs.forEach(function (x) {
          x.it.set(x.to.id);
          if (TRACK.on) { try { x.it.prop('_hok_xp', 'accepted'); } catch (err) {} }
        });
        return parsed.out();
      };
      if (RECENT && RECENT.until > now()) {
        return RECENT.value === 'yes' ? upgrade() : body;
      }
      return ask(swapInfo('network', pairs)).then(function (choice) {
        if (choice === 'yes') return upgrade();
        if (choice === 'no') pairs.forEach(function (x) { rememberNo(x.entry.prod.pid); });
        return body; /* no, or the X: add what they picked */
      });
    }, function () { clearTimeout(timer); return body; });
  }

  function isAdd(url) { return String(url || '').split('#')[0].indexOf('/cart/add') !== -1; }

  if (window.fetch) {
    var chainFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = String((init && init.method) || (input && typeof input !== 'string' && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && String(url || '').indexOf('/cart/clear') !== -1) UP.inCart = false;
        if (method === 'POST' && isAdd(url) && init && init.body != null) {
          var injected = false;
          if (BUNDLE_UP && UP.owned && !UP.inCart && hasKw(window.__hokStrength) && typeof init.body === 'string') {
            try {
              var ob = JSON.parse(init.body);
              if (ob && Array.isArray(ob.items) && !ob.items.some(function (it) { return parseInt(it.id, 10) === BUNDLE_UP.vid; })) {
                ob.items.push(TRACK.on ? { id: BUNDLE_UP.vid, quantity: 1, properties: { _hok_xp: 'accepted' } } : { id: BUNDLE_UP.vid, quantity: 1 });
                init.body = JSON.stringify(ob);
                injected = true;
              }
            } catch (err) {}
          }
          var self = this;
          var original = init.body;
          return screen(original)
            .catch(function () { return original; })
            .then(function (nb) {
              init.body = nb;
              var p = chainFetch.call(self, input, init);
              if (injected) p.then(function (res) { if (res && res.ok) UP.inCart = true; }, function () {});
              if (ACCEPTED) p.then(function (res) { confirmAdded(res && res.ok); }, function () { confirmAdded(false); });
              return p;
            });
        }
      } catch (err) {}
      return chainFetch.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest) {
    var xo = XMLHttpRequest.prototype.open;
    var xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url, async) {
      this.__hokXp = { m: String(method || '').toUpperCase(), u: String(url || ''), sync: async === false };
      return xo.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      var meta = this.__hokXp;
      if (meta && meta.m === 'POST' && !meta.sync && isAdd(meta.u) && body != null) {
        var xhr = this;
        if (ACCEPTED) {
          try { xhr.addEventListener('loadend', function () { confirmAdded(xhr.status >= 200 && xhr.status < 300); }); } catch (err) {}
        }
        screen(body).then(function (nb) { xs.call(xhr, nb); }, function () { xs.call(xhr, body); });
        return;
      }
      return xs.apply(this, arguments);
    };
  }

  /* ---------- ?xp_debug=1 exposes the lookup for testing ---------- */
  if (/[?&]xp_debug=1(&|$)/.test(window.location.search)) {
    window.__hokXp = {
      lookup: lookup,
      twin: function (vid) { return twinOf(VARS[vid]); },
      forget: function (vid) { var e = VARS[vid]; if (e) e.prod.vars.forEach(function (v) { delete VARS[v.id]; }); }
    };
  }

  /* ---------- ?xp_demo=1 opens the popup without adding anything ---------- */
  function demo() {
    if (!/[?&]xp_demo=1(&|$)/.test(window.location.search)) return;
    var pick = null;
    var order = [];
    if (CFG.current && PRODUCTS[CFG.current]) order.push(PRODUCTS[CFG.current]);
    Object.keys(PRODUCTS).forEach(function (k) { order.push(PRODUCTS[k]); });
    for (var n = 0; n < order.length && !pick; n++) {
      var vars = order[n].vars || [];
      for (var k = 0; k < vars.length; k++) {
        var entry = VARS[vars[k].id];
        var to = twinOf(entry);
        if (to) { pick = { entry: entry, to: to, qty: 1 }; break; }
      }
    }
    if (pick) ask(swapInfo('demo', [pick]));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demo);
  else demo();
})();
